import React from 'react'
import BaseTable, {
  ColumnDefinition
} from 'presentation/shared/components/BaseTable'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/delete-rounded.svg'
import { DeleteIconButton } from '../../components/styles'
import { CidV2Props } from 'presentation/contexts/surgical-order-v2/types'

type Props = {
  initialRows: CidV2Props[]
  onDelete: (cidCode: string) => void
}

function CidsTable({ initialRows, onDelete }: Props) {
  const sections = [
    {
      title: '',
      rows: initialRows
    }
  ]

  const columns: ColumnDefinition<CidV2Props>[] = [
    {
      key: 'code',
      header: 'Código',
      width: '10%',
      render: (row) => row.code
    },
    {
      key: 'cid',
      header: 'Nome CID',
      width: '80%',
      render: (row) => row.description
    },
    {
      key: 'actions',
      header: 'Ações',
      width: '10%',
      centered: true,
      render: function renderActions(row) {
        return (
          <DeleteIconButton size="small" onClick={() => onDelete(row.code)}>
            <TrashIcon width={20} height={20} />
          </DeleteIconButton>
        )
      }
    }
  ]

  return (
    <BaseTable
      sections={sections}
      columns={columns}
      emptyState="Nenhum CID foi adicionado ainda"
    />
  )
}

export default CidsTable
